import { getApiActionTypes } from '../redux_utils';

export const ACTIONS = {
  ...getApiActionTypes('FETCH_HOME'),
  ...getApiActionTypes('FETCH_HOME_RELATED_UNITS'),
};
